import React from "react";
import PhoneInput from "react-phone-input-material-ui";
import TextField from "@mui/material/TextField";

function TelephoneField(props) {
  return (
    <PhoneInput
      component={TextField}
      defaultCountry={"pk"}
      inputStyle={{
        width: "100%",
      }}
      inputProps={{
        variant: "outlined", // You can use 'filled' or 'standard' as well
        label: props.label,
        required: props.required,
      }}
      value={props.value}
      onChange={(value) => props.onChange(value, value)}
    />
  );
}

TelephoneField.defaultProps = {
  label: "",
  value: "",
  autoComplete: "",
  disabled: false,
  onChange: () => {},
  onBlur: () => {},
  required: false,
};

export default TelephoneField;
